import React, { useEffect } from "react";
import {Redirect, Route, Switch } from "react-router-dom";
import Landing from "./sections/landing";
import Terms from "./sections/terms";
import Approved from "../global-elements/approved/approved2";
import Declined from "../global-elements/declined";
import { useStoreState } from "easy-peasy";
import DeclinedTemporal from "../global-elements/declinedTemporal";
import '../../../assets/resultPage/resultpage.css';
import Error404 from "../../systempages/error404/Error404";
import GrandBankPage from "../global-elements/grandbank/grandbankPage";
import Offer from "./sections/offer";
import LinkBankAccount from '../linkBankAccount/linkBankAccount';
import { InactiveDetection } from "../../../services/inactiveDetection";
import ApprovedGrandBank from "../global-elements/approved/approved_grandbank";
import TermsGrandBank from "./sections/terms-grandbank";
import OfferGrandBank from "./sections/offer-grandbank";
import PDFTerms from "../global-elements/PDFTerms";
import { PRODUCT } from "../../../models/websiteTypesConstants";

function Layout() {
  const brandSettings = useStoreState(
    (state) => state.siteSettingsModel.brandSettings
  );
  const termsStep = useStoreState(state => state.displayPrequalTerms);
  const resultStep = useStoreState(state => state.displayResult);

  InactiveDetection.setInactiveTitle(null);
  useEffect(() => {
    document.querySelector("title").textContent = `${brandSettings.ProductName} - Mastercard`;
    InactiveDetection.setTitle(`${brandSettings.ProductName} - Mastercard`);
  }, [brandSettings]);

  return (
    <Switch>
      <Route path="/getTerms/:productCode" component={() => <PDFTerms />} exact />
      {/* Landing page No form */}
      <Route path="/" component={() => <Landing />} exact />
      {/* Reservation Page */}
      <Route path="/offer" component={() => brandSettings.ProductName === PRODUCT.Grand.bank ?  <OfferGrandBank /> : <Offer />} exact />
      {/* Terms page No form */}
      <Route path="/terms" component={() => (termsStep) ? (brandSettings.ProductName === PRODUCT.Grand.bank ? <TermsGrandBank /> : <Terms />) : <Redirect to={"/"+window.location.search} />} exact />
      {/* Approved Page */}
      <Route path="/approved" component={() => (resultStep) ? (brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={"/"+window.location.search} />} exact />
      {/* Terms page No form */}
      <Route path="/decision" component={() => (resultStep) ? <Declined /> : <Redirect to={"/"+window.location.search} />} exact />
      <Route path="/grandbank" component={() => (resultStep) ? <GrandBankPage /> : <Redirect to={"/"+window.location.search} />} exact/>
      <Route path="/pendinfo" component={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={"/"+window.location.search} />} exact />
      <Route path="/link-account" component={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={"/" + window.location.search} />} exact />
      <Route  component={() => <Error404 />}  />
    </Switch>
  );
}

export default Layout;
